module.exports = __webpack_public_path__ + "static/img/home-new3.a2a4597a.jpg";